import React, { useContext, useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CalendarIcon } from '../Layout/Svg';

function ButtonField(props) {
  const {
    setOpen,
    label,
    id,
    disabled,
    InputProps: { ref } = {},
    inputProps: { 'aria-label': ariaLabel } = {},
  } = props;

  return (
    <Button
      sx={{ height: '50px', color: '#0000008a !important' }}
      color='secondary'
      variant="outlined"
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      onClick={() => setOpen?.((prev) => !prev)}
      style={{ justifyContent: 'space-between' }}
    >
      {label ? (<>{label + ' '}<span>&nbsp; &nbsp; &nbsp;</span> <CalendarIcon height='24px' width='24px' /></>) : 'Pick a date'}
    </Button>
  );
}

export default function ButtonDatePicker(props) {
  const [open, setOpen] = React.useState(false);

  return (
    <DatePicker
      slots={{ field: ButtonField, ...props.slots }}
      slotProps={{ field: { setOpen } }}
      {...props}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    />
  );
}
